// extracted by mini-css-extract-plugin
export default {"title":"Videos_title__JhWPN","seeMore":"Videos_seeMore__P8sUR"};